import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "success_b414622a4ea3af03bd30b1f26796f6f6",
  "use": "success_b414622a4ea3af03bd30b1f26796f6f6-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"success_b414622a4ea3af03bd30b1f26796f6f6\">\n    <path fill-rule=\"nonzero\" d=\"M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM6.74 8.923L4.725 6.866 3.5 8.118l3.187 3.257L12.5 5.931l-1.171-1.306-4.59 4.298h.001z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol